//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "~/components/objects/IconView.vue";

export default {
  name: "MainEncyclopediaCategories",
  components: { IconView },
  props: {
    branch: {
      type: Object,
      default: null
    }
  },
  async fetch() {
    if (!this.branch && !(this.$store.getters['categories/navTreeDetail'] || []).length) {
      await this.$store.dispatch('categories/getNavTreeDetail')
    }
  },
  computed: {
    categoriesTree() {
      return this.$store.getters['categories/navTreeDetail'] || []
    },
    balancedCategoryColumns() {
      if (this.branch || !this.categoriesTree.length) {
        return []
      }

      if (this.categoriesTree.length < 2) {
        return [this.categoriesTree]
      }

      const weights = this.categoriesTree.map(item => this.branchWeight(item))
      const halfWeight = weights.reduce((sum, weight) => sum + weight, 0) / 2
      let splitIndex = 1
      let currentWeight = 0

      for (let i = 0; i < weights.length - 1; i += 1) {
        const nextWeight = currentWeight + weights[i]
        if (Math.abs(halfWeight - nextWeight) <= Math.abs(halfWeight - currentWeight)) {
          currentWeight = nextWeight
          splitIndex = i + 1
        } else {
          break
        }
      }

      return [
        this.categoriesTree.slice(0, splitIndex),
        this.categoriesTree.slice(splitIndex),
      ].filter(column => column.length)
    },
    category() {
      return this.branch ? this.branch.node : {}
    },
    children() {
      return this.branch && Array.isArray(this.branch.items) ? this.branch.items : []
    },
    categoryLink() {
      return `/s/${this.category.url}`
    },
    materialsCount() {
      const objectsTotal = Number(this.category.objects_total || 0)
      const materialsTotal = Number(this.category.materials_total || 0)
      const total = objectsTotal + materialsTotal

      return total > 0 ? total : null
    }
  },
  methods: {
    branchWeight(branch) {
      if (!branch) return 0
      const children = Array.isArray(branch.items) ? branch.items : []
      return 1 + children.reduce((sum, child) => sum + this.branchWeight(child), 0)
    },
  }
}
